import React from 'react'

/* Catches render crashes so a bad page shows a readable error + a way out,
   instead of white-screening the whole app. */
export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { error: null, info: null }
  }

  static getDerivedStateFromError (error) {
    return { error }
  }

  componentDidCatch (error, info) {
    this.setState({ info })
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info)
  }

  render () {
    const { error, info } = this.state
    if (!error) return this.props.children

    return (
      <div style={{ maxWidth: 760, margin: '48px auto', padding: '0 20px', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ background: '#fff', border: '1px solid #fecaca', borderRadius: 12, padding: 24 }}>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: '#b91c1c', margin: '0 0 8px' }}>Something went wrong on this page</h2>
          <p style={{ fontSize: 14, color: '#6b7280', margin: '0 0 16px' }}>
            The rest of the app is fine — try reloading, or go back to your dashboard.
          </p>
          <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
            <button onClick={() => window.location.reload()}
              style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
              Reload
            </button>
            <button onClick={() => { window.location.href = '/dashboard' }}
              style={{ padding: '9px 16px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', fontWeight: 600, cursor: 'pointer' }}>
              Back to dashboard
            </button>
          </div>
          <details style={{ fontSize: 12, color: '#991b1b' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 600, marginBottom: 6 }}>Error details</summary>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: 12, margin: 0 }}>
{String(error && (error.stack || error.message || error))}
{info && info.componentStack ? '\nComponent stack:' + info.componentStack : ''}
            </pre>
          </details>
        </div>
      </div>
    )
  }
}
